package com.trevorwiebe.timesheet.admin.locations.presentation

import com.trevorwiebe.timesheet.mileage.domain.model.Location
import com.trevorwiebe.timesheet.mileage.domain.model.LocationType

enum class LocationFilter { FUEL, DELIVERY, ACTIVE, DELETED }

data class LocationFormState(
    val name: String = "",
    val city: String = "",
    val state: String = "",
    val type: LocationType = LocationType.DELIVERY,
    val address: String = "",
    val latitude: Double? = null,
    val longitude: Double? = null,
    val validationError: String? = null
)

data class LocationsState(
    val locations: List<Location> = emptyList(),
    val searchQuery: String = "",
    val activeFilters: Set<LocationFilter> = setOf(
        LocationFilter.FUEL,
        LocationFilter.DELIVERY,
        LocationFilter.ACTIVE
    ),
    val showAddEditDialog: Boolean = false,
    val editingLocation: Location? = null,
    val form: LocationFormState = LocationFormState(),
    val showMapPicker: Boolean = false,
    val isGeocoding: Boolean = false,
    val geocodeError: String? = null,
    val isLoading: Boolean = false,
    val error: String? = null,
    // Merge / multi-select
    val selectionMode: Boolean = false,
    val selectedIds: Set<String> = emptySet(),
    val showMergeDialog: Boolean = false,
    val isMerging: Boolean = false
) {
    val visibleLocations: List<Location>
        get() {
            val typeFilters = activeFilters.intersect(setOf(LocationFilter.FUEL, LocationFilter.DELIVERY))
            val statusFilters = activeFilters.intersect(setOf(LocationFilter.ACTIVE, LocationFilter.DELETED))

            val byType = if (typeFilters.isEmpty()) {
                locations
            } else {
                locations.filter { location ->
                    (LocationFilter.FUEL in typeFilters && location.type == LocationType.FUEL) ||
                        (LocationFilter.DELIVERY in typeFilters && location.type == LocationType.DELIVERY)
                }
            }

            val byStatus = if (statusFilters.isEmpty()) {
                byType.filter { !it.deleted }
            } else {
                byType.filter { location ->
                    (LocationFilter.ACTIVE in statusFilters && !location.deleted) ||
                        (LocationFilter.DELETED in statusFilters && location.deleted)
                }
            }

            val query = searchQuery.trim()
            val bySearch = if (query.isEmpty()) {
                byStatus
            } else {
                byStatus.filter { location ->
                    location.name.contains(query, ignoreCase = true) ||
                        location.city.contains(query, ignoreCase = true) ||
                        location.state.contains(query, ignoreCase = true)
                }
            }

            return bySearch.sortedWith(compareBy({ it.name.lowercase() }, { it.city.lowercase() }))
        }
    val selectedType: LocationType?
        get() = locations.firstOrNull { it.id in selectedIds }?.type

    val selectedLocations: List<Location>
        get() = locations.filter { it.id in selectedIds }
}
